import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  HostBinding,
  OnDestroy, Output,
  EventEmitter, HostListener, ViewChild, ElementRef, ChangeDetectorRef
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { StateService } from '@shared/services/state.service';
import { distinctUntilChanged, map, skip, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { MenuMobileActions } from '../../enums/menu-mobile-actions';
import { RecordingState } from '../../enums/recording-state';
import { TokenService } from '@shared/services/token.service';
import { CustomizationModel } from '../../models/customization.model';
import { CustomizationService } from '../../services/customization.service';
import { RealtimeDatabaseSubscriptionsService } from '../../services/rtdb-subscriptions.service';

@UntilDestroy()
@Component({
  selector: 'stusan-menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuMobileComponent implements OnInit, OnDestroy {
  private roomName: string;
  public recordingState$: BehaviorSubject<RecordingState> = new BehaviorSubject<RecordingState>(RecordingState.stop);
  public isRaiseHandEnabled = false;
  public customConfig: CustomizationModel;
  @HostBinding('class.opened') isOpened: boolean;
  @Output() actionChange = new EventEmitter<MenuMobileActions>();
  action: MenuMobileActions;
  destroyed$ = new Subject<boolean>();
  @ViewChild('menu') menu: ElementRef<any>;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.menu.nativeElement.style.setProperty('--menu-height', `${event.target.innerHeight}px`);
  }

  constructor(
    private stateService: StateService,
    private readonly rtdbSubscriptionsService: RealtimeDatabaseSubscriptionsService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly tokenService: TokenService,
    public customizationService: CustomizationService,
  ) {
    this.customConfig = customizationService.config;
  }

  ngOnInit(): void {
    this.setRoomName();
    this.stateService.isMobileMenuShown$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isMobileMenuShown: boolean) => this.isOpened = isMobileMenuShown);

    this.rtdbSubscriptionsService.recordingSubscription$
      .pipe(
        takeUntil(this.destroyed$),
        distinctUntilChanged(),
        map(x => x || RecordingState.stop), // can be null in RTDB, means stopped
      )
      .subscribe((recordingState: RecordingState) => {
        this.changeDetectorRef.detectChanges();
        this.recordingState$.next(recordingState);
      });

    this.tokenService.isHost$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(isHost => {
      if (!isHost) {
        this.isRaiseHandEnabled = true;
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleAction(action: string) {
    this.action = action as MenuMobileActions;
    this.actionChange.emit(this.action);
  }

  tooglePopup() {
    this.stateService.isMobileMenuShown$.next(!this.stateService.isMobileMenuShown$.value);
  }

  private setRoomName(): void {
    this.roomName = this.stateService.roomName as string;
  }
}
